
import React from "react";

export default function SavedFilters({
  savedFilters = {},
  activePeriod,
  showPeriod = false
}) {
  const capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1);

  const formatPeriod = (p) => {
    if (!p) return "";
    if (p.toLowerCase() === "current") return "Current Period";
    if (p.toLowerCase() === "previous") return "Last Period";
    return p;
  };

  const noFilters = !savedFilters || Object.keys(savedFilters).length === 0;

  return (
    <div className="flex flex-col gap-4 mb-8">
      <div
        className="filters-search-panel grid gap-5 flex-1"
        style={{ gridTemplateColumns: "repeat(auto-fit, minmax(130px, 130px))" }}
      >
        {Object.entries(savedFilters).map(([key, value]) => (
          <div key={key} className="filter-items flex flex-col">
            <label className="mb-1">{capitalize(key)}</label>

            <select
              value={value}
              disabled={true}
              className="border border-gray-300 rounded px-2 py-1 h-[40px] bg-gray-100 cursor-not-allowed"
            >
              <option value={value}>{value}</option>
            </select>
          </div>
        ))}

        {showPeriod && (
          <div className="filter-items flex flex-col">
            <label className="mb-1">Period</label>

            <div
              className="rounded px-1 py-1 h-[40px] flex items-center justify-center bg-[#80C6AD] text-white"
            >
              {formatPeriod(activePeriod)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
